<!-- <div class="title-box">
    <div class="title mx-auto">Impact</div>
</div> -->
<section class="section-impact">
    <div class="container">
        <div i18n="comingSoonPage: coming soon" class="d-flex align-items-center justify-content-center py-5 text-center">
            Coming Soon...
        </div>
    </div>
</section>